export const UPDATE_DUO_MFA_TOKEN = 'update_duo_mfa_token';
export const UPDATE_RSA_MFA_TOKEN = 'update_rsa_mfa_token';
export const UPDATE_OKTA_MFA_TOKEN = 'update_okta_mfa_token';
export const UPDATE_PING_MFA_TOKEN = 'update_ping_mfa_token';
export const UPDATE_MICROSOFT_MFA_TOKEN = 'update_microsoft_mfa_token';
export const UPDATE_HYPR_MFA_TOKEN = 'update_hypr_mfa_token';
export const UPDATE_FIDO2_MFA_TOKEN = 'update_fido2_mfa_token';
export const SET_TOKEN_FIELD = 'set_token_field';
export const DELETE_TOKEN = 'delete_token';
export const ADD_MICROSOFT_TENANT = 'add_microsoft_tenant';
export const DELETE_MICROSOFT_TENANT = 'delete_microsoft_tenant';
export const UPDATE_MICROSOFT_TENANT_NAME = 'update_microsoft_tenant';
export const ADD_ENTRA_ID_MFA_TOKEN = 'add_entra_id_mfa_token';
export const UPDATE_ENTRA_ID_MFA_TOKEN = 'update_entra_id_mfa_token';
export const DELETE_ENTRA_ID_MFA_TOKEN = 'delete_entra_id_mfa_token';
